
import { Component, Vue } from "vue-property-decorator";
import { getAbbreviation } from "@/api/supplier";
import Pagination from "@/components/Pagination/index.vue";
import {
  getSalesmanList,
  removeQuotation,
  generatePI,
} from "@/api/inquiry";
import {
  getPiDeliveryStatus,
  getPiCustomerShipmentStatus,
  confirmOrder,
  invalidPi,
  uncancelPi,
  searchPiCode,
} from "@/api/proforma";
import {
  getPoList,
  getPoDetail,
  getOrderStatus,
  downloadPoList,
  auditPass,
  suspend,
  remarkPo,
  updatePackingState,
  downloadTemplate,
  downloadTemplateExcel,
  getCancelReview,
  getCancelSuspend,
  markException,
  markNormal,
  updateContractualDeliveryDate,
  batchDownloadContract,
  batchDownloadDetailContract,
  queryPayments, getPaymentMethod, updatePayments, batchDownloadDetail
} from "@/api/purchase-order";
import Template from "@/views/system-management/template/index.vue";
import MaintainPaymentInfo
  from "@/views-oms/purchase-order-management/order/components/maintain-payment-info/index.vue";
import VirtualList from 'vue-virtual-scroll-list'

@Component({
  name: "managePurchaseOrders",
  components: {
    MaintainPaymentInfo,
    Template,
    Pagination,
    VirtualList,
    CheckReceipt: () => import("./components/check-receipt/index.vue"),
    FileManagement: () =>
      import(
        "@/views-oms/sales-order-management/order/order-management/components/file-management/index.vue"
      ),
    WriteOff: () => import("./components/write-off/index.vue"),
    MarkUnderissued: () => import("./components/mark-underissued/index.vue"),
  },
})
export default class extends Vue {

  private itemComponent = MaintainPaymentInfo;
  private isShowMore = false;
  private downloadLoading = false;
  private isShowMore2 = false;
  private changeIcon = require("@/assets/images/ic_biangeng.png");
  private sampleIcon = require("@/assets/images/ic_include_sample.png");
  private showRemarkDialog = false;
  private remarkText = "";
  private remarkLength = 255;
  private remarkRow: any = null;
  private listLoading = true;
  private showCreate = false;
  private showFile = false;
  private showReceipt = false;
  private showMoney = false;
  private showWrite = false;
  private showStop = false;
  private searchOptions = [];
  private piCode = "";
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    time: [],
  };
  public searchForm = [
    {
      label: "采购订单号",
      prop: "poCode",
      key: "poCode",
      type: "input",
      value: "",
      placeholder: "请输入采购订单号",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "销售员",
      prop: "sellerId",
      key: "sellerId",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
    },
    {
      label: "订单状态",
      prop: "poStatus",
      key: "poStatus",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
    },
    {
      label: "排序方式",
      prop: "positiveSequence",
      key: "positiveSequence",
      type: "select",
      value: false,
      options: [
        {
          name: "正序",
          id: true,
        },
        {
          name: "倒序",
          id: false,
        },
      ],
    },
    {
      label: "下单时间",
      prop: "time",
      key: "time",
      type: "dateTimePickerOne",
      value: "",
      placeholder: "",
    },
  ];
  public supplierId = "";
  public info = {} as any;
  public infoFields = [
    {
      label: "供应商编号",
      key: "code",
    },
    {
      label: "供应商简称",
      key: "abbreviation",
    },
  ] as any;
  public INVOICE_STATUS = [
    {
      label: "供应商编号",
      key: "customerAbbreviation",
    },
    {
      label: "供应商简称",
      key: "createdTime",
    },
  ] as any;

  private selectItem = [];

  created() {
    this.init();
  }
  //
  activated() {
    this.init();
  }

  private init() {
    // console.log('topSupplierId', this.$route.query.supplierId)
    this.supplierId = (this.$route.query.supplierId as string) || "";
    let item = (this.$route.query.item as string) || "";
    this.info = item ? JSON.parse(this.$route.query.item as string) : {};
    this.getOrderStatus();
    this.getSalesmanList();
    this.getList();
    this.getPaymentMethod();
  }

  private paymentMethodOptions = [];
  private async getPaymentMethod() {
    const res: any = await getPaymentMethod();
    this.paymentMethodOptions = res;
  }

  private async getOrderStatus() {
    const res: any = await getOrderStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[3].options = res;
  }

  // 查看回执
  public async handleReceipt(scope) {
    this.selectedItem = scope.row;
    this.showReceipt = true;
  }

  private async downloadTemplate(row) {
    await downloadTemplate(row.row.id)
  }

  private async downloadTemplateExcel(row) {
    await downloadTemplateExcel(row.row.id)
  }

  private deliveryCompleted(row) {
    this.$confirm("确定交货完成吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await updatePackingState(row.row.id);
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private showMore() {
    this.isShowMore = !this.isShowMore;
    this.$nextTick(() => {
      const table = this.$refs.table as any;
      if (table && table.doLayout) {
        table.doLayout();
      }
    });
  }

  private async loadRowDetails(rows) {
    const details: any = await getPoDetail({
      ids: rows.map((item) => item.id),
    });
    const detailList = Array.isArray(details) ? details : [];
    return rows.map((item) => {
      const detail = detailList.find((v) => v.id === item.id);
      return detail ? { ...item, ...detail } : item;
    });
  }

  private async searchPiCode(name = "") {
    if (!name) {
      name = " ";
    }
    if (name.length >= 3) {
      const res: any = await searchPiCode(name);
      this.searchOptions = res;
    }
  }

  private changeValuePiCode(e) {
    const input = document.createElement("input");
    document.body.appendChild(input);
    input.setAttribute("value", e);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
      supplierId: this.supplierId,
    } as any;
    try {
      const res: any = await getPoList(params);
      const { total, list } = res;
      const rows = (list || []).map((item, index) => {
        item.sn = (index + 1) * 1 + (this.table.pageNumber - 1) * this.table.pageSize;
        item.completeCode = item.code + (item.suffix ? "-" + item.suffix : "");
        return item;
      });
      this.table.total = +total;
      if (rows.length) {
        try {
          this.table.list = await this.loadRowDetails(rows);
        } catch (err) {
          console.log(err);
          this.table.list = rows;
        }
      } else {
        this.table.list = rows;
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.listLoading = false;
      this.loading = false;
      this.$nextTick(() => {
        const table = this.$refs.table as any;
        if (table && table.doLayout) {
          table.doLayout();
        }
      });
    }
  }

  // 导出excel
  private isExporting = false;

  // 导出
  private async handleExport() {
    this.downloadLoading = true;
    try {
      await downloadPoList({
        ...this.listParam,
      });
    }finally {
      this.downloadLoading = false;
    }
  }

  private showBatchPayment = false;
  private paymentInfoList = [];
  private canDownload = false;
  private async batchPaymentInfo() {
    if (this.selectItem.length === 0) {
      this.$message.error('请选择采购订单');
      return;
    }
    const ids = this.selectItem.map(item => item.id);
    const res = await queryPayments({ids: ids}) as any;
    this.canDownload = res.every(item => item.passed === true);
    this.paymentInfoList = res;
    this.showBatchPayment = true;
  }

  private batchDownloadDetailLoading = false;

  private async batchDownloadDetail() {
    if (this.selectItem.length === 0) {
      this.$message.error('请选择采购订单');
      return;
    }
    this.batchDownloadDetailLoading = true;
    const ids = this.selectItem.map(item => item.id);
    try{
      await batchDownloadDetail(ids);
    }catch (error) {
      console.error(error);
    }finally {
      this.batchDownloadDetailLoading = false;
    }
  }

  private canConfirm = false;
  private async confirmPaymentInfo() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await updatePayments({poPaymentInfoReqs: this.paymentInfoList}).then(() => {
      this.getList();
      this.paymentInfoList.forEach(item => item.passed = true)
      this.canDownload = true;
      loading.close();
      this.canConfirm = true;
      this.$notify({
        title: '成功',
        message: '付款及交期维护成功',
        type: 'success'
      });
    }).catch(() => {
      loading.close();
    });
  }

  private batchPaymentClose() {
    this.showBatchPayment = false;
    this.canConfirm = false;
  }

  private async batchDownloadContract(command) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      const ids = this.selectItem.map(item => item.id);
      const data = {purchaseOrderIds: ids};
      if (command === 'detail') {
        await batchDownloadDetailContract(data);
      }
      if (command === 'contract') {
        await batchDownloadContract(data);
      }
    } catch (err) {
      console.error(err);
    }finally {
      loading.close();
    }
  }

  public handleOpenContractualDeliveryDate(row, refName) {
    row.isContractualDeliveryDate = true;
    const ref = this.$refs[refName] as any;
    const popover = Array.isArray(ref) ? ref[0] : ref;
    if (popover && popover.$refs && popover.$refs.popper) {
      popover.$refs.popper.hidden = true;
    }
  }

  private async handleContractualDeliveryDate(row) {
    console.log(row);
    await updateContractualDeliveryDate({id: row.id, contractualDeliveryDate: row.newContractualDeliveryDate});
    row.contractualDeliveryDate = row.newContractualDeliveryDate;
    row.isContractualDeliveryDate = false;
    this.$notify({
      title: "提示",
      message: "修改约定交期成功！",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async createPaymentOrder(row) {
    let params = {
      abbreviation: row.row.supplierAbbr,
    };
    const res = await getAbbreviation(params);
    if (res) {
      this.$router.push({
        name: "createPaymentOrder",
        query: {
          factoryAbbreviationName: row.row.supplierAbbr,
          factoryAbbreviationID: row.row.supplierId,
          hqPackingListCode: row.row.code,
          type: "ToListPurchase",
        },
      });
    }
  }

  private showLookReason = false;
  private lookReasonText = '';
  private lookReason(row) {
    this.showLookReason = true;
    this.lookReasonText = row.row.reviewRemark;
  }

  // 创建供应商扣款
  public handleCreate() {
    this.showCreate = true;
  }

  private handleSuccess() {
    this.showCreate = false;
    this.showMoney = false;
    this.selectedRows = [];
    this.clearSelection();
    this.getList();
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.id);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePI(scope) {
    this.$alert(scope.row.approvalRecordId, "PI号码", {
      confirmButtonText: "复制",
      callback: () => {
        this.h5Copy(scope.row.approvalRecordId);
      },
    });
  }

  public handleRemarks(item) {
    this.handleRemark(item);
  }

  // 填写备注
  public async handleRemark(item) {
    // 订单备注
    try {
      await remarkPo({
        ids: [item.id],
        remark: item.remark,
      });
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private async handleAbnormal(row) {
    await markException(row.row.id).then(async res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    }).catch(err => {
      console.log(err);
    });
  }

  private handleSelectionChange(val: any) {
    this.selectItem = val;
  }

  private clearSelection() {
    const table = this.$refs.table as any;
    if (table && table.clearSelection) {
      table.clearSelection();
    }
  }

  private text(value) {
    if (value === 0) {
      return 0;
    }
    if (value === "null" || value === "undefined" || value == null) {
      return "";
    }
    return value || "";
  }

  private customerText(row) {
    if (row.pcName && row.pcName.length > 0) {
      return `[${row.pcName}]${row.customer || ""}`;
    }
    return this.text(row.customer);
  }

  private matchText(source, value) {
    if (value == null || value === "") {
      return false;
    }
    return String(source).indexOf(value) > -1;
  }

  private onDownloadCommand(command, row) {
    if (command === "detail") {
      this.downloadTemplate({ row });
    }
    if (command === "contract") {
      this.downloadTemplateExcel({ row });
    }
  }

  private onMoreCommand(command, row) {
    if (command === "stop") {
      this.handleStop({ row });
    } else if (command === "flow") {
      this.gotoDocumentFlow({ row });
    } else if (command === "payment") {
      this.handleCreatePayment({ row });
    } else if (command === "delivery") {
      this.deliveryCompleted({ row });
    } else if (command === "abnormal") {
      this.handleAbnormal({ row });
    } else if (command === "normal") {
      this.handleNormal({ row });
    }
  }

  private openRemark(row) {
    this.remarkRow = row;
    this.remarkText = row.remark;
    this.remarkLength = 255;
    this.showRemarkDialog = true;
  }

  private confirmRemark() {
    const item = {
      ...this.remarkRow,
      remark: this.remarkText,
    };
    this.remarkText = "";
    this.showRemarkDialog = false;
    this.handleRemarks(item);
  }

  private rowClassForDD({ row }) {
    if (row.abnormal) {
      return "error-row";
    }
    return "";
  }

  private async handleNormal(row) {
    await markNormal(row.row.id).then(async res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    }).catch(err => {
      console.log(err);
    });
  }

  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[2].options = res;
  }

  private async getPiCustomerShipmentStatus() {
    const res: any = await getPiCustomerShipmentStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[7].options = res;
  }

  private async getPiDeliveryStatus() {
    const res: any = await getPiDeliveryStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[6].options = res;
  }

  public querySearch(data) {
    console.log(data);
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.startTime = time[0];
      rest.endTime = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleCustomer() {
    // empty
  }

  private linkClick(scope) {
    this.$router.push(
      `/purchaseOrderDetails?id=${scope.row.id}&supplierId=${scope.row.supplierId}`
    );
  }

  public selectedItem = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    this.showMoney = true;
  }

  // 采购订单跳转单据流
  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "PURCHASE_ORDER", documentId: data.row.id },
    });
  }

  // 文件管理
  public async handleFile(scope) {
    this.selectedItem = scope.row;
    this.showFile = true;
  }

  // 核销
  public async handleWriteOff(scope) {
    this.selectedItem = scope.row;
    this.showWrite = true;
  }

  // 终止订单
  public async handleStop(scope) {
    await this.itemAssignment(scope.row);
    this.showStop = true;
    const ref: any = this.$refs["stopOrder"];
    ref.getList();
  }

  itemAssignment(row) {
    this.selectedItem = row;
  }

  // handleCreatePayment
  public async handleCreatePayment(scope) {
    console.log("scope.row", scope.row);
    let params = {
      abbreviation: scope.row.supplierAbbr,
    };
    const res = await getAbbreviation(params);
    if (res) {
      this.$router.push(`/createPaymentOrder?supplierId=${scope.row.supplierId}&code=${scope.row.code}&type=cgdd&supplierAbbr=${scope.row.supplierAbbr}&factoryAbbreviationName=${scope.row.supplierAbbr}&codesType=PURCHASE_ORDER&showBtnStatus=false`);
    }
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleUncancelPi(scope) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await uncancelPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 挂起
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
      inputValue: scope.row.reviewRemark,
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await suspend(scope.row.id, {
          remark: value,
        });
        this.getList();
      })
      .catch(() => {
        // empty
        console.log(111111);
      });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private selectedRows = [];

  private async getCancelReview(row) {
    this.$confirm("确定取消审核吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      await getCancelReview(row.row.id).then(res => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      }).catch(err => {
        console.log(err);
      });
    })
    .catch((err) => {
      console.error(err);
    });
  }

  private async getCancelSuspend(row) {
    this.$confirm("确定取消挂起吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      await getCancelSuspend(row.row.id).then(res => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      }).catch(err => {
        console.log(err);
      });
    })
    .catch((err) => {
      console.error(err);
    });
  }
}
